module.exports = __webpack_public_path__ + "img/新增.c38b28c2.svg";